import { useEffect, useRef, RefObject } from 'react';

interface IUseOutsideClick {
  modalRef: RefObject<HTMLDivElement>;
  containerRef: RefObject<HTMLDivElement>;
}

/**
 * Hook that alerts clicks outside of the passed ref
 */
export const useOutsideClick = (callback: () => void): IUseOutsideClick => {
  const modalRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent | TouchEvent) => {
      // Check if the click was outside the element referenced by 'ref'
      if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
        callback();
      }
    };

    const container = containerRef.current;

    // Bind the event listener
    container?.addEventListener('mousedown', handleClickOutside);
    container?.addEventListener('touchstart', handleClickOutside);

    return () => {
      // Unbind the event listener on clean up
      container?.removeEventListener('mousedown', handleClickOutside);
      container?.removeEventListener('touchstart', handleClickOutside);
    };
  }, [callback]);

  return { modalRef, containerRef };
};
